var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.735,
    height: 14.453,
    viewBox: "0 0 16.735 14.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.521,3A1.521,1.521,0,0,0,1,4.521v9.128a1.521,1.521,0,0,0,1.521,1.521h.761a.761.761,0,1,0,0-1.521H2.521V4.521H16.213v9.128h-.761a.761.761,0,1,0,0,1.521h.761a1.521,1.521,0,0,0,1.521-1.521V4.521A1.521,1.521,0,0,0,16.213,3ZM9.367,8.325a2.282,2.282,0,1,0,2.282,2.282A2.241,2.241,0,0,0,9.367,8.325Zm0,6.085C6.874,14.41,4.8,15.5,4.8,16.692v.38a.38.38,0,0,0,.38.38h8.367a.38.38,0,0,0,.38-.38v-.38C13.931,15.5,11.861,14.41,9.367,14.41Z",
    transform: "translate(-1 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.e54ddbedf03d2a1907be1e6e62404d8e.svg";
export { ForwardRef as ReactComponent };